import React from "react";

import RandingStyle27 from "../../randing/RandingStyle27";

function Randing485({ urlCode, urlCodeSettingId }) {
  const imageAltTexts = {
    step1:
      "창원에 위치한 치과입니다 설문 참여하고 국산정품 임플란트 혜택 받으세요 개당 38만원 0% 01 임플란트는 누구를 위해 알아보고 계시나요? 본인 가족 혹은 지인",
    step2:
      "창원에 위치한 치과입니다 설문 참여하고 국산정품 임플란트 혜택 받으세요 개당 38만원 50% 02 성함과 연락처를 입력해주세요",
    step3:
      "창원에 위치한 치과입니다 설문 참여하고 국산정품 임플란트 혜택 받으세요 개당 38만원 마지막 확인입니다 03 동의 시 전문 상담원이 무료상담해 드립니다",
  };

  const stepImages = {
    step1: `${process.env.REACT_APP_CDN_BASE}/images/485/01.jpg`,
    step2: `${process.env.REACT_APP_CDN_BASE}/images/485/02(1).png`,
    step3: `${process.env.REACT_APP_CDN_BASE}/images/485/03.jpg`,
  };

  return (
    <>
      <style>{`
        @media (min-width: 769px) {
          .randing-style-27 .step3 .step-content {
            bottom: 7% !important;
          }
        }
      `}</style>
      <RandingStyle27
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        imageFolderPath={`${process.env.REACT_APP_CDN_BASE}/images/485`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/144/bluegif.gif`}
        companyName="본원"
        imageAltTexts={imageAltTexts}
        stepImages={stepImages}
      />
    </>
  );
}

export default Randing485;
